import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
import { ApiService } from '../services/apiService';
import {
  PdmAssignmentService,
  type IPdmAssignmentService,
} from '../services/pdmAssignmentService';
import { GraphDirectoryService } from '../services/graphDirectoryService';

/**
 * Builds a PDM assignment service backed by the current MSAL session.
 */
export function usePdmAssignmentService(): IPdmAssignmentService | null {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0] ?? null;

  return useMemo(
    () =>
      account
        ? new PdmAssignmentService(
            new ApiService(instance, account),
            new GraphDirectoryService(instance, account),
          )
        : null,
    [instance, account],
  );
}
